import { Component, Input } from '@angular/core';
import { BeneMobile } from '../../../models/bene-mobile/bene-mobile';

@Component({
    selector: '[bene_mobile_entity_view]',
  templateUrl: 'bene-mobile-entity-view.component.html',
})

export class BeneMobileEntityViewComponent {
  @Input()
  element: BeneMobile;
}
